export default {

    // inline settings
    buttonHref: 'https://www.appjustable.com',
    buttonTarget: '_blank',
    buttonText: 'Add Text',

    // style tag settings
    buttonTextFontSize: 14,
    buttonTextFontSizeTablet: null,
    buttonTextFontSizePhone: null,

    buttonPaddingHorizontal: 20,
    buttonPaddingVertical: 10,
    buttonPaddingHorizontalTablet: null,
    buttonPaddingVerticalTablet: null,
    buttonPaddingHorizontalPhone: null,
    buttonPaddingVerticalPhone: null,

    buttonMarginTop: 10,
    buttonMarginBottom: 10,

    buttonWidthSelect: 'auto',
    setButtonWidth: false,
    buttonWidth: 150,
    buttonMaxWidth: 'none',
    buttonWidthValue: 'auto',

    buttonWidthSelectTablet: null,
    setButtonWidthTablet: false,
    buttonWidthTablet: null,
    buttonMaxWidthTablet: null,
    buttonWidthValueTablet: null,

    buttonWidthSelectPhone: null,
    setButtonWidthPhone: false,
    buttonWidthPhone: null,
    buttonMaxWidthPhone: null,
    buttonWidthValuePhone: null,

    // widthClass: '',
    buttonBg: '#aaa',
    buttonBgHover: '#333',
    textColor: '#fff',
    textColorHover: '#fff',

    letterSpacing: 0,
    letterSpacingTablet: null,
    letterSpacingPhone: null,
    
    lineHeight: 1.2,
    lineHeightTablet: null,
    lineHeightPhone: null,

    borderRadiusGlobal: 3,

    showBorderRadiusIndividual: false,
    borderRadiusLeftTop: 3,
    borderRadiusRightTop: 3,
    borderRadiusRightBottom: 3,
    borderRadiusLeftBottom: 3,

    borderColor: '#aaa',
    borderColorHover: '#333',
    borderWidth: 1,
    borderStyle: 'solid',

    useButtonShadow: false,
    useButtonShadowOnHover: true,
    useButtonShadowOnNormal: false,
    buttonBoxShadowColor: 'rgba(0,0,0,.2)',
    buttonShadowHorizontal: 2,
    buttonShadowVertical: 7,
    buttonBlurRadius: 12,
    buttonSpreadRadius: 1,


    buttonAlignement: 'center',
    buttonAlignementTablet: null,
    buttonAlignementPhone: null,

    hoverClass: 'hvr-fade',

    useIcon: false,

    useCustomFont: false,
    customFontName: "'Helvetica Neue', sans-serif",
    customFontWeight: "400",
    customFontStyle: 'normal',
    
    iconClass: 'fab fa-weebly',
    useIconAfter: false,
    useIconBefore: true,
    iconPosition: 'useIconBefore',
    iconMargin: 7,

    fontFamily: 'Roboto',
    fontWeight: '400',
    fontStyle: 'normal',
    fontGoogleLoad: 'Roboto:400'
    
}


// WEBPACK FOOTER //
// ./src/store/elementSettings/buttonsettings.js